export const TEAM_TYPES_DOCUMENTATION_LINK =
	'https://support.atlassian.com/platform-experiences/docs/what-are-team-types/';
export const TEAM_TYPES_PERMISSIONS_DOCUMENTATION_LINK =
	'https://support.atlassian.com/platform-experiences/docs/delegate-permissions-for-team-types/';

export const CUSTOM_FIELD_COLUMNS: string[] = ['name', 'description', 'actions'];
